import i18n from "i18next"
import moment from "moment"

import "moment/dist/locale/fr"
import { initReactI18next } from "react-i18next"
import en from "shared/locales/en.json"
import fr from "shared/locales/fr.json"

const storedLanguage =
  localStorage.getItem("language") || navigator.language.split("-")[0] || "fr"

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    fr: {
      translation: fr,
    },
  },
  lng: storedLanguage,
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false,
  },
})

moment.locale(i18n.language === "fr" ? "fr" : "en")

export default i18n
